
class AvailabilityBlock extends HTMLElement {
    /* Track data-product-handle changes */
    static get observedAttributes() {
        return ["data-product-handle"];
    }

    attributeChangedCallback(name, oldValue, newValue) {

        if (newValue)
            this.url = newValue;

        this.getProductInfos(newValue);

    }

    /* Inject data */
    async getProductInfos(url) {
        const html = await fetch(url + "/?sections=availability-wrapper")
            .then((response) => response.json());

        const div = document.createElement("div");
        div.innerHTML = html["availability-wrapper"];
        this.append(div);

    }

}

customElements.define('availability-block', AvailabilityBlock);


/*Affichage date */
class AvailabilityDate extends HTMLElement {

    constructor() {

        super();
        // propriétés fiches produit
        this.productRef = this.getAttribute("product-ref");
        this.displayButton = this.getAttribute("display-button");
        this.currentVariant = this.getAttribute("current-variant");

        // si on est pas sur une fifche produit on affiche simpelment la date
        if (!this.productRef)
            this.style.display = 'flex'
    }

    /* Track data-product-handle changes */
    static get observedAttributes() {
        return ["current-variant"];
    }

    attributeChangedCallback(name, oldValue, newValue) {

        switch (name) {
            case "current-variant"    :

                this.currentVariant = this.getAttribute("current-variant");
                this.setDisplay();

                break;
        }
    }

    // Selectionne la date à afficher et affiche le bouton acheter en focntion du variant selectionné
    setDisplay() {

        const buyButtons = document.querySelectorAll('[availability-display]')

        if (this.currentVariant === this.productRef) {

            this.style.display = 'flex';
            const display = this.displayButton === "true" ? 'block' : 'none'

            buyButtons.forEach(button => {
                button.style.display = display;
            })


        } else {
            //this.style.display = 'none';
        }
    }
}

customElements.define('availability-date', AvailabilityDate);

// récupoère le paramètre href des élements dynamqiues
class AvailabilityTarget extends HTMLElement {

    constructor() {
        super();

        /* Nf : update webcomponent*/
        const a = this.querySelector('[data-product-title]');
        const url = a.getAttribute("href");

        if (!url)
            return;

        /* Nf : update webcomponent*/
        const handle = this.querySelector('[data-product-handle]');
        const handleUrl = url.replace(/\?variant=\d+/, "");
        handle.setAttribute('data-product-handle', handleUrl);

    }

}

customElements.define('availability-target', AvailabilityTarget);
